<template>
  <vx-card>
    <vs-popup title :active.sync="subAccountInvitePopup.display">
      <div class="px-8 py-8 md:px-12 md:py-12">
        <h1 class="prompt-titles mb-8">Add Subaccount</h1>
        <div class="mb-8">
          <label class="prompt-labels">Email Address</label>
          <vs-input
            class="w-full mt-2"
            data-vv-validate-on="input|keyup|blur"
            name="email"
            placeholder="Ex.name@gmail.com"
            v-validate="`required|email`"
            @change="isValidEmailForInvite"
            v-model="inviteSubAccountData.email"
          />
          <span
            class="mt-1 text-danger text-sm block"
            v-show="errors.has('emailValidationError')"
          >{{ errors.first('emailValidationError') }}</span>
          <span
            class="mt-1 text-danger text-sm block"
            data-vv-validate-on="input|keyup|blur"
            v-show="errors.has('email')"
          >{{ errors.first('email') }}</span>
        </div>

        <div>
          <label class="prompt-labels">Account Name</label>
          <p class="text-gray-500 mt-2">The account name must be unique</p>
          <vs-input
            maxlength="35"
            name="account name"
            data-vv-validate-on="input|keyup|blur"
            placeholder="Account name"
            v-validate="'required|min:6|max:35'"
            class="w-full mt-1 shadow-none"
            v-model="inviteSubAccountData.accountName"
          />

          <span
            class="mt-1 text-danger text-sm block"
            v-show="errors.has('account name')"
          >{{ errors.first('account name') }}</span>

          <span
            class="mt-1 text-danger text-sm block"
            v-show="errors.has('invitationResponseError')"
          >{{ errors.first('invitationResponseError') }}</span>

        </div>
        <div class="flex flex-wrap mt-8 md:flex-no-wrap md:justify-end">
          <vs-button class="primary-btns w-full mb-4 md:mb-0 md:order-last md:w-48 shadow-none h-12" @click="inviteSubAccount">Invite</vs-button>
          <vs-button class="cancel-btns w-full md:mr-6 md:w-40 shadow-none h-12" text-color="#2C2C2C" type="border" @click="hidePopup"> Cancel </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- success popup -->
    <vs-popup title="Success" :active.sync="inviteSubAccountData.successPopup" :buttons-hidden="true">
      <div class="flex flex-col items-center px-6 py-8 md:px-12 md:py-12">
        <img class="mb-10 w-24 h-24 md:w-32 md:h-32" src="@/assets/images/account-details/icons8-approval 1.svg">
        <p class="confirm-box-body mb-6">
          Invitation has been successfully sent.
        </p>
        <vs-button v-on:click="inviteSubAccountData.successPopup = false" class="primary-btns w-full md:w-56 h-12">Ok</vs-button>
      </div>
    </vs-popup>

    <div class="flex status_labels space-x-10 float-right">
      <div>
        <div class="approved-icon mr-2"></div>
        Active Account
      </div>

      <div>
        <div class="pending-icon mr-2"></div>
        Pending Account
      </div>

      <div class="">
        <div class="blocked-icon mr-2"></div>
        Blocked Account
      </div>
    </div>

    <div class="w-full mt-5 tree-div">
      <Tree @noInvites="noInvitesCallback" @resend="inviteSubAccountData.successPopup = true" ref="treeComponent" />
    </div>
    <div class="w-full text-center no-invites" v-if="noInvites">
        <div>There are no sub accounts</div>
        <div>Expecting to see something ? try to add sub accounts</div>
      </div>
  </vx-card>
</template>

<script>
import Tree from './components/Tree'

export default {
  components: {
    Tree
  },
  data () {
    return {
      inviteSubAccountData: this.resetSubAccountData(),
      authenticatedUserEmail: this.$store.getters['authentication/user']['email'],
      noInvites: false
    }
  },
  mounted () {
    this.$parent.setupTabsBar()
  },
  computed: {
    userEmail () {
      return this.$store.getters['authentication/user'].email || ''
    },
    subAccountInvitePopup () {
      return this.$store.getters['settings/subAccountInvitePopup']
    },
    currentAccount () {
      return this.$store.getters['authentication/activeAccount']
    }
  },
  methods: {
    resetSubAccountData () {
      return {
        email: '',
        accountName: '',
        successPopup: false
      }
    },
    noInvitesCallback (noInvites) {
      this.noInvites = noInvites
    },
    hidePopup () {
      this.$store.commit('settings/SUB_ACCOUNT_INVITE_POPUP', {
        display: false,
        email: ''
      })
      this.inviteSubAccountData.accountName = ''
      this.inviteSubAccountData.email = ''
      this.errors.clear()
      this.$validator.reset()
    },

    async inviteSubAccount () {

      this.errors.clear()
      try {
        await this.$validator.validateAll()
        const {email, accountName: account_name} = this.inviteSubAccountData

        // Check if email is not auth user email
        this.isValidEmailForInvite()

        if (!this.errors.any()) {
          const accountId = this.subAccountInvitePopup.id

          await window.axios.post(
            '/accounts/invitations',
            {
              account_name,
              email,
              account_id: accountId
            }
          ).then(() => {
            // Reinitalize form data
            this.inviteSubAccountData = this.resetSubAccountData()

            // Remove all validations errors
            this.$validator.reset()

            this.$store.commit('settings/SUB_ACCOUNT_INVITE_POPUP', {
              display: false,
              id: ''
            })

            this.inviteSubAccountData.successPopup = true

            this.$store.dispatch('settings/members').then(() => {
              this.$refs.treeComponent.createTreeData()
            })
          }).catch(error => {
            this.errors.add({
              field: 'invitationResponseError',
              msg: error.response.data.errors && Object.values(error.response.data.errors)[0][0]
            })
          })
        }
      } catch (error) {
        this.errors.add({
          field: 'invitationResponseError',
          msg: error.response && error.response.data && error.response.data.message
        })
      }

    },

    isValidEmailForInvite () {
      if (this.currentAccount.type === 'Shared') {
        return
      }
      if (this.inviteSubAccountData.email === this.authenticatedUserEmail) {
        this.errors.add({
          field: 'emailValidationError',
          msg: 'You can not invite your email as a sub account.'
        })
      } else {
        this.errors.remove('emailValidationError')
      }
    }
  }
}
</script>

<style lang="scss">

.vx-card__body {
  padding-top: 0 !important;
}

.primary-btns {
  height: 48px;
  background: #0092d7 !important;
  border-radius: 3px;
  color: white !important;
}

input[type=text],
button {
  box-shadow: none;
}

.google-visualization-orgchart-node {
  border-radius: 15px;
}

.cancel-btns {
  height: 48px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 3px;
  color: rgba(0, 0, 0, 0.65) !important;
  border: 2px solid #d9d9d9 !important;
}

.prompt-titles {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.prompt-body {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.56);
}

.prompt-labels {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

.prompt-hints {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: #0092d7;
}

.tree-div {
  height: 550px;
  overflow-y: scroll;
  padding-top: 30px;
  overflow-x: scroll;
}

.no-invites {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.107143px;
  color: rgba(0, 0, 0, 0.56);
}

.google-visualization-orgchart-table {
  margin: auto;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 30%;
}

.status_labels {
  font-size: 12px;

  div {
    float: right;

    div.approved-icon {
      background: rgb(45, 205, 122);
      height: 10px;
      width: 10px;
      float: left;
      margin-top: 5px !important;
      border-radius: 50%;
    }

    div.pending-icon {
      background: #f2af03;
      height: 10px;
      width: 10px;
      float: left;
      margin-top: 5px !important;
      border-radius: 50%;
    }

    div.blocked-icon {
      background: red;
      height: 10px;
      width: 10px;
      float: left;
      margin-top: 5px !important;
      border-radius: 50%;
    }
  }
}
</style>
